import React, { useEffect, useState, useRef } from "react";
import BreadCrumbComp from "../../../components/breadCrumb";
import { icons } from "../../../constants";
import LaddaButton from "../../../components/buttons/laddaButton";
import {
  getOptionName,
  months,
  requestState
} from "../../../constants/selectData";
import SimpleTable from "../../../components/tables/simpleTable";
import SimpleSelect from "../../../components/selects/simpleSelect";
import { useForm } from "react-hook-form";
import "../styles.css";
import "../summaryTable.css";
import "../filterStyles.css";
import { Grid } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  resetOrderState,
  resetServiceOrderId,
  setServiceOrderId
} from "../../../redux/slices/serviceOrderSlice";
import {
  callApiAsync,
  callActionApiAsync,
  getSelectsServiceOrder,
  getServiceOrderNotification,
  getServiceOrderTableData,
  updateServiceOrderEngineer
} from "../../../services/apiService";
import { hasAnyRoleUtil } from "../../../services/roleService";
import HistoryModal from "../modals/historyModal";
import CalendarSection from "./calendarSection";
import LoadingFeedback, { useLoadingState } from "../../../components/loadingFeedback";
import ReassignmentEngineer from "../modals/reassignmentEngineer";
import NotificationsModal from "../modals/notificationsModal";
import { formatCustomDate } from "../../../services/dateService";
import MultiSelect from "../../../components/selects/multiSelect";
import {
  formatCustomDateName,
  formatMonthYear
} from "../../../utils/dateUtils";
import { orderSelectActivity } from "../../../utils/orderActivity";
import { useServiceOrdersFilters } from "../../../context/ServiceOrdersFiltersContext";
import {
  BIOMEDICAL_SERVICE_ORDER_ASSIGN_ENGINEER_ROLES,
  BIOMEDICAL_SERVICE_ORDER_EDIT_ROLES
} from "../../../constants/biomedicalRoles";

const EMPTY_FILTERS = {
  type: [],
  equipment: null,
  serieId: [],
  state: null,
  institution: [],
  date: null,
  engineer: null
};

const BioMedicalRequest = () => {
  const [loadingTable, setLoadingTable] = useLoadingState(true);
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.userData.userData);
  const navigate = useNavigate();
  const validationSchema = {};
  const {
    filters,
    setFilters,
    clearFilters,
    markKeep,
    consumeKeep,
    getStoredFilters,
    clearKeep
  } = useServiceOrdersFilters();

  const canEditServiceOrder = hasAnyRoleUtil(
    BIOMEDICAL_SERVICE_ORDER_EDIT_ROLES,
    userData.roleList
  );
  const canAssignEngineer = hasAnyRoleUtil(
    BIOMEDICAL_SERVICE_ORDER_ASSIGN_ENGINEER_ROLES,
    userData.roleList
  );
  const isReadOnlyServiceOrder = !canEditServiceOrder;
  const isServiceOrderManagment = canEditServiceOrder;
  dispatch(resetOrderState());

  const [originalTableData, setOriginalTableData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [tableLoading, setTableLoading] = useState(false);
  const [tableError, setTableError] = useState("");
  const [appliedFilters, setAppliedFilters] = useState(filters || EMPTY_FILTERS);
  const [dateKeys, setDateKeys] = useState([]);
  const [optionsReady, setOptionsReady] = useState(false);
  const [calendarPeriod, setCalendarPeriod] = useState(() => ({
    year: new Date().getFullYear(), month: new Date().getMonth() + 1
  }));
  const requestSequence = useRef(0);
  const calendarSequence = useRef(0);
  const pageSize = 15;
  const [openHistory, setOpenHistory] = useState(false);
  const [openNotifications, setOpenNotifications] = useState(false);
  const [openChangeEng, setOpenChangeEng] = useState(false);

  const [activities, setActivities] = useState([]);
  const [serviceOId, setServiceOId] = useState([]);
  const [serieOId, setSerieOId] = useState([]);
  const [stateOId, setStateOId] = useState([]);
  const [dateFilters, setDateFilters] = useState([]);
  const [institutionFilters, setInstitutionFilters] = useState([]);
  const [selectedServiceOrder, setSelectedServiceOrder] = useState(null);
  const [engineerList, setEngineerList] = useState([]);
  const [notification, setNotification] = useState([]);
  const [engineerInChargeData, setEngineerInChargeData] = useState([]);

  const {
    control: controlTable,
    getValues: getValuesTable,
    reset
  } = useForm({
    defaultValues: filters || {}
  });

  dispatch(resetServiceOrderId());

  const handleOpenHistory = () => {
    setOpenHistory(true);
  };

  const handleOpenChangeEng = () => {
    setOpenChangeEng(true);
  };

  const handleCloseHistory = () => {
    getTableData();
    getCalendarData();
    setSelectedServiceOrder(null);
    setOpenHistory(false);
    setOpenNotifications(false);
    setOpenChangeEng(false);
  };

  const handleChangeTable = () => {
    const formData = getValuesTable();
  };

  const serviceOrderColumns = [
    {
      field: "biomedical_equipment",
      header: "Nro. de serie",
      columnType: "columnList",
      property: "serie_number"
    },
    {
      field: "biomedical_equipment",
      header: "Equipo",
      columnType: "columnList",
      property: "name"
    },
    {
      field: "biomedical_equipment",
      header: "Modelo",
      columnType: "columnList",
      property: "model"
    },
    {
      field: "activity_name",
      header: "Tipo de Orden de Servicio",
      columnType: "custom",
      render: (rowData) => (
        <p className="table-default-column" title={rowData.activity_name || ""}>
          {rowData.activity_name}
        </p>
      )
    },
    {
      field: "service_order_id",
      header: "",
      columnType: "hide"
    },
    {
      field: "state",
      header: "Estado",
      columnType: "custom",
      render: (rowData) => (
        <p className="table-default-column" title={getOptionName(requestState, rowData.state)}>
          {getOptionName(requestState, rowData.state)}
        </p>
      )
    },
    {
      field: "service_order_name", header: "OS", columnWidth: "100px",
      columnType: "custom",
      render: (rowData) => (
        <p className="table-default-column" title={rowData.service_order_name || ""}>
          {rowData.service_order_name}
        </p>
      )
    },

    {
      field: "creation_date",
      header: "Fecha de creación",
      columnType: "custom",
      render: (rowData) => (
        <p className="table-default-column">
          {formatCustomDate(rowData.creation_date)}
        </p>
      ),
      columnWidth: "115px"
    },
    { field: "institution_id", header: "", columnType: "hide" },
    {
      field: "institution_name", header: "Intitución",
      columnType: "custom",
      render: (rowData) => (
        <p className="table-default-column" title={rowData.institution_name || ""}>
          {rowData.institution_name}
        </p>
      )
    },
    { field: "actionButtons", columnType: "actionButtons" }
  ];

  const selectsServiceOrder = () => {
    callApiAsync(
      () => getSelectsServiceOrder(),
      (data) => {
        setEngineerInChargeData(
          data.enginnerList.filter((engineer) => Number(engineer.is_active) === 1)
        );
      }
    );
  };

  const additionaeOrderManagmentButton = canAssignEngineer
    ? {
        type: "icon",
        icon: icons.cambiarUsuario,
        onClick: (rowData) => {
          setSelectedServiceOrder(rowData);
          handleOpenChangeEng();
        }
      }
    : null;

  const buttons = [
    {
      type: "icon",
      icon: icons.eye,
      onClick: (rowData) => {
        dispatch(setServiceOrderId(rowData.service_order_id));

        // Guardamos filtros actuales y marcamos "keep"
        const currentFilters = getValuesTable();
        setFilters(currentFilters); // guarda en context + sessionStorage
        markKeep(); // indica que al volver debemos restaurar

        // navega a la misma ruta de la vista (view)
        navigate(
          "/biomedicalManagementDashboard/BioMedicalRequest/createRequest",
          {
            state: { viewOnly: true, rowData }
          }
        );
      }
    },
    ...(additionaeOrderManagmentButton ? [additionaeOrderManagmentButton] : [])
  ];

  const getTableData = async () => {
    const sequence = ++requestSequence.current;
    setTableLoading(true);
    setTableError("");
    const selectedDate = dateKeys.find((date) => date.name === appliedFilters.date);
    await callActionApiAsync(
      () =>
        getServiceOrderTableData(
          userData.id,
          isReadOnlyServiceOrder
            ? isReadOnlyServiceOrder
            : isServiceOrderManagment,
          { page: currentPage, pageSize, filters: JSON.stringify({
            ...appliedFilters,
            date: selectedDate?.value,
            states: requestState.filter((state) => state.name === appliedFilters.state)
              .map((state) => state.value)
          }) }
        ),
      (data) => {
        if (sequence !== requestSequence.current) return;
        setTableData(data.items);
        setTotalRecords(data.total);
        if (data.total > 0 && currentPage > Math.ceil(data.total / pageSize)) {
          setCurrentPage(Math.ceil(data.total / pageSize));
        }
      },
      () => {
        if (sequence !== requestSequence.current) return;
        setTableData([]);
        setTotalRecords(0);
        setTableError("No se pudieron cargar las ordenes de servicio.");
      },
      setLoadingTable
    );
    if (sequence === requestSequence.current) setTableLoading(false);
  };

  const getFilterOptions = async () => {
    await callActionApiAsync(
      () => getServiceOrderTableData(userData.id, isServiceOrderManagment, { view: "filters" }),
      (data) => {
        setActivities(orderSelectActivity(data.activities));
        setServiceOId(data.orders.map((order) => ({ name: order.name, value: order.name })));
        setSerieOId(data.series);
        setStateOId(data.states.map(({ state }) => ({
          name: getOptionName(requestState, state), value: getOptionName(requestState, state)
        })));
        const dates = data.dates.map((date) => ({
          value: date.value, name: formatCustomDateName(new Date(date.creation_date))
        }));
        setDateKeys(dates);
        setDateFilters(dates.map((date) => ({ name: date.name, value: date.name })));
        setOptionsReady(true);
      },
      () => setTableError("No se pudieron cargar las opciones de filtro.")
    );
  };

  const getCalendarData = async () => {
    const sequence = ++calendarSequence.current;
    await callActionApiAsync(
      () => getServiceOrderTableData(userData.id, isServiceOrderManagment,
        { view: "calendar", ...calendarPeriod }),
      (data) => { if (sequence === calendarSequence.current) setOriginalTableData(data); },
      () => { if (sequence === calendarSequence.current) setOriginalTableData([]); }
    );
  };

  const getNotifications = async (user_id) => {
    const dataToSend = isServiceOrderManagment ? 0 : user_id;
    callApiAsync(
      () => getServiceOrderNotification(dataToSend),
      (data) => {
        setNotification(data);
      }
    );
  };

  const applyFilterToTable = (filtersObj) => {
    setFilters(filtersObj);
    setAppliedFilters(filtersObj);
    setCurrentPage(1);
  };

  const handleClearFilters = () => {
    const EMPTY_FILTERS = {
      date: null,
      type: [],
      equipment: null,
      serieId: [],
      state: null,
      institution: [],
      engineer: null
    };

    clearFilters();
    reset(EMPTY_FILTERS, { keepDirty: false, keepTouched: false });
    setAppliedFilters(EMPTY_FILTERS);
    setCurrentPage(1);
  };

  useEffect(() => {
    const optionsReady =
      activities.length ||
      serviceOId.length ||
      serieOId.length ||
      stateOId.length ||
      institutionFilters.length ||
      dateFilters.length;

    if (optionsReady) {
      if (filters) {
        reset(filters);
      } else {
        reset(EMPTY_FILTERS);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    activities.length,
    serviceOId.length,
    serieOId.length,
    stateOId.length,
    institutionFilters.length,
    dateFilters.length
  ]);

  useEffect(() => {
    if (!optionsReady) return;
    getTableData();
    return () => { requestSequence.current += 1; };
  }, [currentPage, appliedFilters, dateKeys, optionsReady]);

  useEffect(() => {
    getCalendarData();
    return () => { calendarSequence.current += 1; };
  }, [calendarPeriod]);

  const getSelectData = async () => {
    callApiAsync(
      () => getSelectsServiceOrder(),
      (data) => {
        setInstitutionFilters(data.institutionList);
        setEngineerList(data.enginnerList);
      }
    );
  };

  const updateReassignmentEngineer = async (data) => {
    callApiAsync(
      () => updateServiceOrderEngineer(data),
      (data) => {
        handleCloseHistory();
      }
    );
  };

  useEffect(() => {
    getNotifications(userData.id);
    selectsServiceOrder();
    getSelectData();
    getFilterOptions();
  }, []);

  return (
    <div>
      <BreadCrumbComp />
      <div className="searchTitle">
        <h1>ORDEN DE SERVICIO</h1>

        <LaddaButton
          variant="contained"
          onClick={() => setOpenNotifications(true)}
          margin={"0"}
          color={"#404040"}
          backgroundColor={"#F4D658"}
          height={"42px"}
        >
          {notification ? (
            <div className="notification-circle">{notification.length}</div>
          ) : (
            <div className="notification-circle bg-gray">0</div>
          )}
          <p className="button_text">Alertas OS</p>
        </LaddaButton>
      </div>
      <div className="table-container">
        <div className="HContainer j-space-between">
          <h1 className="title-bio-details-chard">Orden de Servicio</h1>
          {isServiceOrderManagment && (
            <LaddaButton
              variant="contained"
              height={"32px"}
              onClick={() => {
                clearKeep();
                navigate(
                  "/biomedicalManagementDashboard/BioMedicalRequest/createRequest",
                  {
                    state: { viewOnly: false, data: { id: 0 } }
                  }
                );
              }}
            >
              <div className="IHContainer align-center">
                <img
                  className="btn-icon"
                  src={icons.plusIcon}
                  alt="icon"
                  style={{ marginRight: "10px" }}
                />
                <p className="button_text">Crear Requerimiento</p>
              </div>
            </LaddaButton>
          )}
        </div>

        <div className="table-container">
          <h1 className="request-title-calendar">
            AGENDA DE ORDEN DE SERVICIO
          </h1>

          <LoadingFeedback loading={loadingTable} variant="spinner" preserveLayout>
            <CalendarSection orderData={originalTableData} onPeriodChange={setCalendarPeriod}/>
          </LoadingFeedback>
        </div>

        <div>
          <br className="br-white-space" />
          <div className="HContainer j-end">
            <></>
            <LaddaButton
              variant="contained"
              // width={"200px"}
              height={"32px"}
              onClick={() => handleOpenHistory()}
            >
              <div className="IHContainer align-center">
                <img
                  className="btn-icon"
                  src={icons.historialWhite}
                  alt="icon"
                  style={{ marginRight: "10px" }}
                />
                <p className="button_text">Historial</p>
              </div>
            </LaddaButton>
          </div>

          <div className="mt-25 mb-10">
            <form
              style={{
                display: "flex",
                display: "flex",
                alignItems: "center"
              }}
            >
              <Grid container rowSpacing={3} columnSpacing={3} alignItems="flex-end" className="biomedical-filters">
                <Grid item xs={12} sm={3} md={3}>
                  <MultiSelect
                    name="type"
                    control={controlTable}
                    label="Tipo de Orden"
                    options={activities}
                    onChange={handleChangeTable}
                    margin={"0"}
                    isMultiple={true}
                    searchBar={true}
                  />
                </Grid>
                <Grid item xs={12} sm={3} md={3}>
                  <MultiSelect
                    name="equipment"
                    control={controlTable}
                    label="Nro. de OS"
                    options={serviceOId}
                    onChange={handleChangeTable}
                    margin={"0"}
                    isMultiple={false}
                    searchBar={true}
                  />
                </Grid>
                <Grid item xs={12} sm={3} md={3}>
                  <MultiSelect
                    name="serieId"
                    control={controlTable}
                    label="Nro. de serie"
                    options={serieOId}
                    margin={"0"}
                    // error={errors.serie}
                    isMultiple={false}
                    searchBar={true}
                  />
                </Grid>
                <Grid item xs={12} sm={3} md={3}>
                  <SimpleSelect
                    name="engineer"
                    control={controlTable}
                    label="Ingeniero/a"
                    options={engineerList}
                    margin={"0"}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <SimpleSelect
                    name="state"
                    control={controlTable}
                    label="Estado"
                    options={stateOId}
                    onChange={handleChangeTable}
                    margin={"0"}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <MultiSelect
                    name="institution"
                    control={controlTable}
                    label="Institución"
                    options={institutionFilters}
                    margin={"0"}
                  />
                </Grid>
                <Grid item xs={12} sm={4} md={4}>
                  <MultiSelect
                    name="date"
                    control={controlTable}
                    label="Fecha de Creación"
                    options={dateFilters}
                    isMultiple={false}
                    searchBar={true}
                    margin={"0"}
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={12}>
                  <div className="IHContainer j-end">
                    <LaddaButton
                      variant="contained"
                      onClick={() => applyFilterToTable(getValuesTable())}
                      margin={"0"}
                    >
                      <img
                        className="btn-icon"
                        src={icons.filterWhite}
                        alt="icon"
                      />
                    </LaddaButton>
                    <LaddaButton
                      variant="contained"
                      onClick={handleClearFilters}
                      margin={"0 0 0 10px"}
                    >
                      <img
                        className="btn-icon"
                        src={icons.clearFilterWhite}
                        alt="icon"
                      />
                    </LaddaButton>
                  </div>
                </Grid>
              </Grid>
            </form>
          </div>
          {tableError && <p role="alert">{tableError}</p>}
          <div className="biomedical-summary-table biomedical-service-order-table biomedical-rounded-table">
          <SimpleTable
            tableStyle={{ tableLayout: "fixed", width: "100%", minWidth: "1100px" }}
            loading={loadingTable}
            data={tableData}
            serverPagination
            totalRecords={totalRecords}
            currentPage={currentPage}
            rowsPerPage={pageSize}
            hidePaginatorRowsDropdown
            onPageChange={setCurrentPage}
            columns={serviceOrderColumns}
            text={"Realizar Autoevaluación"}
            isPaginated={true}
            sortable
            buttons={buttons}
            showItemCount={true}
          />
          </div>
        </div>
      </div>
      <HistoryModal
        open={openHistory}
        isManagment={isServiceOrderManagment}
        close={handleCloseHistory}
        userId={userData.id}
        isViewer={isReadOnlyServiceOrder}
      />
      <NotificationsModal
        open={openNotifications}
        isManagment={isServiceOrderManagment}
        close={handleCloseHistory}
        userId={userData.id}
      />
      <ReassignmentEngineer
        open={openChangeEng}
        close={handleCloseHistory}
        data={selectedServiceOrder}
        onInput={updateReassignmentEngineer}
        selectData={engineerInChargeData}
        userData={userData}
      />
    </div>
  );
};

export default BioMedicalRequest;
